import classnames from 'classnames';

const {
  i18n: { __ },
  components: { TabPanel, SlotFillProvider, createSlotFill, Icon },
  blockEditor: { InspectorControls },
} = wp;
const environment = process.env.NODE_ENV;
const developerMode = environment === 'development';

const { Slot: InspectorTabGeneralSlot, Fill: InspectorTabGeneralFill } =
  createSlotFill('InspectorTabGeneral');
const { Slot: InspectorTabAppearanceSlot, Fill: InspectorTabAppearanceFill } =
  createSlotFill('InspectorTabAppearance');
const { Slot: InspectorTabDeveloperSlot, Fill: InspectorTabDeveloperFill } =
  createSlotFill('InspectorTabDeveloper');

const InspectorControlsGeneral = ({ children }) => {
  return <InspectorTabGeneralFill>{children}</InspectorTabGeneralFill>;
};

const InspectorControlsAppearance = ({ children }) => {
  return <InspectorTabAppearanceFill>{children}</InspectorTabAppearanceFill>;
};

const InspectorControlsDeveloper = ({ children }) => {
  return <InspectorTabDeveloperFill>{children}</InspectorTabDeveloperFill>;
};

const InspectorTabs = ({ children }) => {
  const tabPanelClasses = classnames({
    'components-panel__tabs': true,
    'b3rg-panel-tabs': true,
    'col-2': !developerMode,
  });

  const tabPanels = [
    {
      name: 'tab-general',
      title: __('General', ''),
      icon: (
        <>
          <Icon icon="screenoptions" />
          <span>{__('General', '')}</span>
        </>
      ),
      content: <InspectorTabGeneralSlot />,
    },
    {
      name: 'tab-appearance',
      title: __('Appearance', ''),
      icon: (
        <>
          <Icon icon="admin-appearance" />
          <span>{__('Appearance', '')}</span>
        </>
      ),
      content: <InspectorTabAppearanceSlot />,
    },
    ...(developerMode
      ? [
          {
            name: 'tab-developer',
            title: __('Developer', ''),
            icon: (
              <>
                <Icon icon="admin-tools" />
                <span>{__('Developer', '')}</span>
              </>
            ),
            content: <InspectorTabDeveloperSlot />,
          },
        ]
      : []),
  ];

  return (
    <InspectorControls key="BergTabs">
      <SlotFillProvider>
        <TabPanel
          className={tabPanelClasses}
          activeClass="active-tab"
          tabs={tabPanels}
        >
          {({ content }) => <>{content}</>}
        </TabPanel>
        {children}
      </SlotFillProvider>
    </InspectorControls>
  );
};

export {
  InspectorTabs,
  InspectorControlsGeneral,
  InspectorControlsAppearance,
  InspectorControlsDeveloper,
};
